import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppState } from '@smdapp/flux/state/app.state';
import { STORE_PROVIDERS } from './export';


@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [CommonModule],
  providers: [AppState, ...STORE_PROVIDERS]
})

export class FluxModule {}
